(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mbl-curated-product-cards-core-base"] && !Shopify.designMode) return;
  try {
    const initializeMblCuratedCarousels = (scope = document) => {
    scope.querySelectorAll('[data-mbl-curated-carousel]').forEach((carousel) => {
      if (carousel.dataset.mblCarouselReady === 'true') return;

      const track = carousel.querySelector('[data-mbl-carousel-track]');
      const previousButton = carousel.querySelector('[data-mbl-carousel-previous]');
      const nextButton = carousel.querySelector('[data-mbl-carousel-next]');

      if (!track || !previousButton || !nextButton) return;

      carousel.dataset.mblCarouselReady = 'true';

      const getScrollStep = () => {
        const firstCard = track.querySelector('.mbl-curated-card');
        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;

        if (firstCard) {
          return firstCard.getBoundingClientRect().width + gap;
        }

        return Math.max(track.clientWidth * 0.82, 260);
      };

      const updateControls = () => {
        const maximumScrollLeft = Math.max(track.scrollWidth - track.clientWidth, 0);
        const isScrollable = maximumScrollLeft > 4;

        carousel.dataset.scrollable = isScrollable ? 'true' : 'false';
        previousButton.disabled = !isScrollable || track.scrollLeft <= 4;
        nextButton.disabled = !isScrollable || track.scrollLeft >= maximumScrollLeft - 4;
      };

      const scrollCards = (direction) => {
        track.scrollBy({
          left: direction * getScrollStep(),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      };

      previousButton.addEventListener('click', () => scrollCards(-1));
      nextButton.addEventListener('click', () => scrollCards(1));

      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollCards(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollCards(1);
        }
      });

      let scrollFrame;
      track.addEventListener(
        'scroll',
        () => {
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(updateControls);
        },
        { passive: true },
      );

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateControls);
        resizeObserver.observe(track);
        carousel.mblResizeObserver = resizeObserver;
      } else {
        window.addEventListener('resize', updateControls, { passive: true });
      }

      window.requestAnimationFrame(updateControls);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeMblCuratedCarousels());
  } else {
    initializeMblCuratedCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeMblCuratedCarousels(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mbl-extra-multipack-cards"] && !Shopify.designMode) return;
  try {
    const appendMblExtraMultipacks = (scope = document) => {
    scope.querySelectorAll("[data-mbl-extra-multipacks]").forEach((source) => {
      const track = document.getElementById(source.dataset.mblExtraTarget);
      if (!track) return;

      const fragment = document.createDocumentFragment();
      Array.from(source.children).forEach((card) => fragment.appendChild(card));
      track.appendChild(fragment);
      source.remove();

      window.requestAnimationFrame(() => track.dispatchEvent(new Event("scroll")));
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => appendMblExtraMultipacks());
  } else {
    appendMblExtraMultipacks();
  }

  document.addEventListener("shopify:section:load", (event) => {
    appendMblExtraMultipacks(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mbl-scotts-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mbl-scotts-picker')) {
    customElements.define('mbl-scotts-picker', class extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-scotts-data]').textContent);
        this.section = this.closest('.shopify-section');
        this.observers = new Map();
        this.pendingFrame = 0;
        this.deadline = Date.now() + 20000;
        this.navigationKey = 'mbl-scotts-selection';
        this.restore = null;
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.navigationKey) || 'null');
          if (saved && saved.path === location.pathname && Date.now() - saved.time < 60000) {
            this.restore = saved;
            sessionStorage.removeItem(this.navigationKey);
          }
        } catch {}
        this.onChange = () => this.schedule();
        this.onNavigate = event => this.navigate(event);
        this.addEventListener('click', this.onNavigate);
        this.observe(this.section);
        this.sync();
        this.hydrationTimer = setInterval(() => {
          this.sync();
          if (this.ready || Date.now() > this.deadline) clearInterval(this.hydrationTimer);
        }, 150);
      }
      disconnectedCallback() {
        clearInterval(this.hydrationTimer);
        cancelAnimationFrame(this.pendingFrame);
        this.removeEventListener('click', this.onNavigate);
        this.observers.forEach((observer, root) => {
          observer.disconnect();
          root.removeEventListener('change', this.onChange, true);
        });
        this.observers.clear();
      }
      observe(root) {
        if (!root || this.observers.has(root)) return;
        const observer = new MutationObserver(() => this.schedule());
        observer.observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['rc-selected','value','checked']});
        root.addEventListener('change', this.onChange, true);
        this.observers.set(root, observer);
      }
      schedule() {
        if (this.pendingFrame) return;
        this.pendingFrame = requestAnimationFrame(() => { this.pendingFrame = 0; this.sync(); });
      }
      state() {
        const widget = this.section.querySelector('recharge-subscription-widget');
        const root = widget?.shadowRoot;
        const plans = root?.querySelector('rc-selling-plans')?.shadowRoot;
        const select = plans?.querySelector('select');
        const selected = root?.querySelector('input[name="purchaseOption"]:checked');
        const days = select?.selectedOptions[0]?.textContent.match(/\d+/)?.[0] || '30';
        return {widget, root, plans, select, selected, days, subscription:selected?.value === 'subscription'};
      }
      setText(element, value) {
        if (element && element.textContent !== value) element.textContent = value;
      }
      sync() {
        if (!this.isConnected) return;
        const state = this.state();
        this.observe(state.root);
        this.observe(state.plans);
        this.ready = Boolean(state.selected && state.widget.dataset.mblPurchaseDefault);
        if (this.restore && this.ready) {
          const saved = this.restore;
          if (saved.review) {
            const notice = this.querySelector('[data-scotts-status]');
            notice.hidden = false;
            this.setText(notice, this.config.frequencyReview);
            this.restore = null;
          } else if (saved.subscription && !state.subscription) {
            const radio = state.root.querySelector('input[value="subscription"]');
            if (radio && !radio.disabled) {
              radio.click();
              return;
            }
            const notice = this.querySelector('[data-scotts-status]');
            notice.hidden = false;
            this.setText(notice, this.config.unavailable);
            this.restore = null;
          } else if (saved.subscription && state.select) {
            const option = [...state.select.options].find(option => option.textContent.match(/\d+/)?.[0] === saved.days);
            this.restore = null;
            if (option && option.value !== state.select.value) {
              state.select.value = option.value;
              state.select.dispatchEvent(new Event('change', {bubbles:true}));
              return;
            }
          } else if (!saved.subscription) {
            this.restore = null;
          }
        }
        const cards = [...this.querySelectorAll('[data-option-group="pack"]')];
        const prices = cards.map(card => {
          const product = this.config.products[card.dataset.targetProduct];
          const plan = state.subscription && (product.plans.find(plan => plan.name.match(/\d+/)?.[0] === state.days) || product.plans[0]);
          const price = plan || product.base;
          this.setText(card.querySelector('[data-scotts-total]'), price.total);
          this.setText(card.querySelector('[data-scotts-unit]'), price.unit);
          return {card, product, unit:price.price / product.pack};
        });
        const minimum = Math.min(...prices.filter(p => p.product.available).map(p => p.unit));
        prices.forEach(({card,product,unit}) => {
          card.querySelector('[data-scotts-best]').hidden = prices.length < 2 || product.pack < 2 || unit !== minimum;
        });
        this.setText(this.querySelector('[data-scotts-basis]'), state.subscription ? this.config.subscription : this.config.onetime);
      }
      navigate(event) {
        const link = event.target.closest('[data-scotts-link]');
        if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const url = new URL(link.href);
        if (url.pathname === location.pathname) { event.preventDefault(); return; }
        const state = this.state();
        const product = this.config.products[link.dataset.targetProduct];
        const review = state.subscription && !product.plans.some(plan => plan.name.match(/\d+/)?.[0] === state.days);
        try {
          sessionStorage.setItem(this.navigationKey, JSON.stringify({path:url.pathname, subscription:state.subscription, days:state.days, review, time:Date.now()}));
        } catch {}
        this.setAttribute('aria-busy','true');
        this.setText(this.querySelector('[data-scotts-status]'),this.config.loading);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
